<template>
<div class="row">

    <div class="col-xl-3">
        <div class="card card-custom gutter-b card-stretch">
            <div class="card-header border-0 pt-5">
                <div class="card-title">
                    <div class="card-label">
                        <div class="font-weight-bolder">Lista de Eventos</div>
                        <div class="font-size-sm text-muted mt-2">{{listEvents.length}} encontrados</div>
                    </div>
                </div>
            </div>
            <div class="card-body d-flex flex-column px-0">
                <div class="d-flex justify-content-between py-5 px-3">
                    <div class="d-flex align-items-center position-relative mr-2">
                        <span class="svg-icon svg-icon-1 position-absolute ml-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                                <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                            </svg>
                        </span>
                        <input type="text" class="form-control form-control-solid w-250px pl-12" v-model="search" :placeholder="'Buscar...'">
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="col-xl-9">
        <div class="card card-custom gutter-b card-stretch ">

            <div class="card-body">
                <div class="card-columns">

                    <div class="card card-hover" v-for="(evento, index) in filterEvents" :key="index">
                        <div @click="goToDetails(evento)">
                            <div class="card-img-top h-150px" :style="'background:url(' + evento.logo + ') center center / cover no-repeat fixed;'"></div>
                            <!--<img class="card-img-top" src="''" alt="Card image cap">-->
                            <div class="card-body">
                                <h5 class="card-title font-weight-bolder text-center" v-text="evento.name"></h5>
                                <ul class="card-text list-unstyled">
                                    <li v-if="evento.place!=null"><i class="fas fa-map-marker-alt mr-3"></i>{{evento.place}}</li>
                                    <li><i class="far fa-calendar-alt mr-3"></i>{{$moment(evento.startdate).format('DD MMM')}}
                                        <span v-if="evento.startdate != evento.enddate"> - {{$moment(evento.enddate).format('DD MMM YYYY')}}</span>
                                    </li>
                                    <li><i class="far fa-user mr-3 d-none"></i>0 registrados</li>
                                    <li v-if="evento.deadline"><i class="far fa-clock mr-3"></i>Inscripciones hasta {{$moment(evento.deadline).format('DD MMM hh:mm A')}}</li>

                                </ul>
                                <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                <div class="btn btn-sm btn-block" :class="[evento.register=='1' ? 'btn-outline-success' : 'btn-outline-danger']">Inscripciones {{evento.register == '1' ? 'abiertas' : 'cerradas'}}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
//import services
import pservice from "@/core/services/pbapi.service"

import {
    ADD_BODY_CLASSNAME,
    REMOVE_BODY_CLASSNAME
} from "@/store/htmlclass.module.js";

export default {
    data: () => ({
        search: '',
        listEvents: []
    }),
    computed: {
        filterEvents: function () {
            this.tableEvents = this.listEvents;
            return this.tableEvents.filter(data => !this.search || data.name.toLowerCase().includes(this.search.toLowerCase()))
        },
    },
    methods: {
        async getData() {
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await pservice.getEvents().then((res) => {
                this.listEvents = res.data
                //console.log(res.data)
            }).catch((err) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            }).finally(() => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        goToDetails(a) {
            this.$router.push({
                name: "Details",
                params: {
                    id: a,
                }
            });
        }
    },
    created() {
        this.getData()
    }
}
</script>
